import ResultNode from "../ResultNode";


import { Fragment } from "react";

export default function ResultList(props) {
  const {
    answer,
    questionNumber,
    correctSingleAnswers,
  } = props;

  return (
    answer.map((it, idx) => (
      <Fragment key={questionNumber + "-" + idx}>
        <ResultNode
          data={it}
          idx={idx + 1}
          correctSingleAnswers={correctSingleAnswers}
        />
       
      </Fragment>
    ))
     


  );
}
